import { TransportType } from "@syla/shared/types/helpers/TransportType";
import { AddWalletRequestBody } from "@syla/shared/types/requests/AddWalletRequest";
import { AddWalletResponse } from "@syla/shared/types/responses/AddWalletResponse";
import axios from "axios";
import { throwSylaApiError } from "../errors/throwSylaApiError";

export async function addWallet(
  accountId: string,
  wallet: AddWalletRequestBody,
): Promise<AddWalletResponse> {
  try {
    const response = await axios.post<TransportType<AddWalletResponse>>(
      `/accounts/${accountId}/wallets`,
      wallet,
    );
    return response.data;
  } catch (error) {
    throwSylaApiError(error);
  }
}
